import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import { execute } from 'store/configureStore';
import * as sagaLetters from 'sagas/lettersNew';
import { addNotification } from 'actions/notifications/notifications';
import { useMutation } from 'react-query';

const ToSpamButton = ({
    letterId, onSuccess, disabled = false, ...rest
}) => {
    const spamMutation = useMutation(
        id => execute(sagaLetters.saveAsSpam, id),
        {
            onSuccess: (result) => {
                if (result.status === 200 && onSuccess) {
                    onSuccess();
                }
            },
            onError: (err) => {
                console.error(err);
                addNotification({
                    title: 'Error',
                    message: 'Failed to mark email as spam.',
                    level: 'error',
                    _id: Math.random(),
                    autoDismiss: 3,
                });
            },
        },
    );

    return (
        <RaisedButton
            className='btn'
            labelStyle={{ fontSize: '10px' }}
            style={{ height: '25px', margin: '10px 10px 10px 0' }}
            buttonStyle={{ 
                height: '25px', 
                lineHeight: '25px', 
                backgroundColor: disabled ? '#E5E5E5' : '#3f51b5',
            }}
            label='To spam'
            onClick={() => spamMutation.mutate(letterId)}
            disabled={disabled}
            secondary
            {...rest}
        />
    );
};

ToSpamButton.propTypes = {
    letterId: PropTypes.string.isRequired,
    onSuccess: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

ToSpamButton.defaultProps = {
    disabled: false,
};

export default ToSpamButton;



// WEBPACK FOOTER //
// ./app/components/Letters/common/ToSpamButton.jsx